"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.words = void 0;
function words(str) {
    return str
        .replace(/[A-Z]+|[0-9]+/g, x => `.${x.toLowerCase()}`)
        .replace(/[^a-z0-9]+/g, '.')
        .split('.')
        .filter(Boolean);
}
exports.words = words;
